"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailNewsLetter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const info_card_1 = require("./info-card");
const EmailNewsLetter = ({ editDetails, isEmailSubscribed, }) => {
    const EmailNewsLetterField = [
        {
            label: 'Subscription Preferences',
            value: isEmailSubscribed === undefined
                ? ' '
                : isEmailSubscribed
                    ? 'Send me email newsletter updates'
                    : 'No, I do not wish to receive emails',
        },
    ];
    return ((0, jsx_runtime_1.jsx)(info_card_1.default, { title: "Email Newsletter", infoFields: EmailNewsLetterField, editProps: editDetails }));
};
exports.EmailNewsLetter = EmailNewsLetter;
